var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"material-icons right tooltipped",attrs:{"data-position":"bottom","data-tooltip":_vm.docs[_vm.index-1].body}},[_vm._v("help")])
}
var staticRenderFns = []

export { render, staticRenderFns }